import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=79b2871b&scoped=true&"
import script from "./Holiday.vue?vue&type=script&lang=ts&"
export * from "./Holiday.vue?vue&type=script&lang=ts&"
import style0 from "./Holiday.vue?vue&type=style&index=0&id=79b2871b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2871b",
  null
  
)

export default component.exports